import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { memo, useEffect, useReducer } from 'react';
// eslint-disable-next-line no-restricted-imports
import { useIntl } from 'react-intl';

import { APP_SETTINGS } from '../../app-settings';
import { SentryService } from '../../services/sentry';
import { dayJsLocales } from '../../utils/dayjs-locales';

let loadLocalePromise = null;

function PatternFormattedDateUI({ value, pattern }) {
  const timezone = APP_SETTINGS.TIMEZONE;
  const { locale } = useIntl();

  const [, forceUpdate] = useReducer(x => x + 1, 0);

  useEffect(() => {
    if (!dayJsLocales[locale]) return;

    if (!loadLocalePromise) loadLocalePromise = dayJsLocales[locale]();

    loadLocalePromise.then(() => forceUpdate()).catch(error => SentryService.captureException(error));
  }, [forceUpdate]);

  return dayjs(value)
    .locale(locale)
    .tz(timezone)
    .format(pattern);
}

PatternFormattedDateUI.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  pattern: PropTypes.string.isRequired,
};

export const PatternFormattedDate = memo(PatternFormattedDateUI);
